import React from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line no-unused-vars
import './styles.css';


const Button = ({
  to, type, children, className, ...props
}) => {
  if (to) {
    return (
      <Link
        styleName={className && className !== '' ? className : 'btn'}
        to={to}
        {...props}
      >
        {children}
      </Link>
    );
  }
  return (
    <button
      styleName={className && className !== '' ? className : 'btn'}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};


export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js